import { useQuery } from "@tanstack/react-query";
import { getSupabase } from "@/lib/hooks/api/utils";
import { TicketTemplate } from "@/lib/types/database";

export function useTicketTemplates(params?: { includeInactive?: boolean }) {
  return useQuery<TicketTemplate[]>({
    queryKey: ["ticket-templates", params?.includeInactive || false],
    queryFn: async () => {
      const supabase = getSupabase();
      let query = supabase.from("ticket_templates").select("*");
      if (!params?.includeInactive) {
        query = query.eq("is_active", true);
      }
      const { data, error } = await query.order("name");

      if (error) {
        console.error("Error fetching ticket templates:", error);
        throw new Error(error.message);
      }

      return data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
